<style lang="stylus" scoped>
.progress {
  border-style: solid;
  border-radius: 8px;
  padding: 2px;
  border-color: black;
  height: 30px;
}

.greyCircle {
  color: black;
  background-color: #E8E7E7;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  padding: 5px 10px;
  margin-right: 2px;
}

.whiteCircle {
  border: 1px solid #fff;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  background: #fff;
  font-size: 12px;
  padding: 5px 7px;
  font-weight: 500;
  margin-bottom: 0px;
  color: #28a745;
}

.card-border-background {
  border: 3px solid rgb(0, 0, 0, 0.05);
  padding: 15px 10px 15px 10px;
}

.inside-card-background {
  background: #F2F2F2 0% 0% no-repeat padding-box;
  opacity: 1;
  padding: 10px 8px 10px 8px;
}
</style>

<template>
  <v-row row wrap style="margin-bottom: 2rem !important">
    <v-col v-if="pathwayCompletionDate">
      <svg height="10" width="100%">
        <line x1="0" y1="0" x2="100%" y2="0" style="stroke: #d0d0d0; stroke-width: 2" />
      </svg>
    </v-col>
    <v-col cols="12" style="border: 1px solid rgb(0, 0, 0, 0.05); padding: 15px">
      <v-row justify-space-between class="subheading font-weight-bold" style="padding-bottom: 12px">
        <!-- <v-col lg1 md2 sm1 xs2>
          <v-icon color="#fec627">mdi-chart-line</v-icon>
        </v-col> -->
        <v-col cols="9" xl="7" md="8" sm="10">
          <span>Credit Progress</span>
        </v-col>
        <v-col cols="5" xl="4" md="4" sm="2" style="text-align: end">
          <span class="greyCircle">{{ earnedCredits }}</span>
          <span>of {{ totalCredits }}</span>
        </v-col>
      </v-row>
      <div class="inside-card-background">
        <v-col cols="12" style="max-width: 450px">
          <div class="progress">
            <div
              class="progress-bar progress-bar-warning"
              role="progressbar"
              aria-valuenow="70"
              aria-valuemin="0"
              aria-valuemax="100"
              v-bind:style="{ width: calcGpa + '%' }"
            />
          </div>
        </v-col>
        <v-col v-if="!pathwayCompletionDate" cols="12" md="12" lg="12" sm="12" style="padding: 0px 5px">
          <v-row>
            <!-- <v-col md1 xs1 sm1>
            <v-icon style="color: #ffc527; margin: 6px">mdi-chevron-right</v-icon>
          </v-col> -->
            <v-col cols="11" md="11" sm="11" style="padding-right: 8px">
              <span style="font-weight: 400; font-size: 14px">
                You need
                <span style="font-weight: bold">{{ requiredCredits }}</span> more credits with a minimum of 2.75 GPA to
                earn general admission to ASU. Please note that if you are enrolled in a Pathway, your requirements may
                differ. See your Pathway page for more details.
              </span>
            </v-col>
          </v-row>
        </v-col>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CreditProgress',

  props: {
    earnedCredits: {
      type: Number,
      required: true
    },
    totalCredits: {
      type: Number,
      required: true
    },
    pathwayName: {
      type: String
    },
    pathwayCompletionDate: String
  },

  computed: {
    calcGpa() {
      return (this.earnedCredits / this.totalCredits) * 100;
    },

    creditDifference() {
      return this.totalCredits - this.earnedCredits;
    },

    requiredCredits() {
      return this.creditDifference >= 0 ? this.creditDifference : 0;
    }
  },

  methods: {}
});
</script>
